var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66683 0.666656H2.00016C1.0835 0.666656 0.34183 1.41666 0.34183 2.33332L0.333496 15.6667C0.333496 16.5833 1.07516 17.3333 1.99183 17.3333H12.0002C12.9168 17.3333 13.6668 16.5833 13.6668 15.6667V5.66666L8.66683 0.666656ZM10.3335 14H3.66683V12.3333H10.3335V14ZM10.3335 10.6667H3.66683V8.99999H10.3335V10.6667ZM7.8335 6.49999V1.91666L12.4168 6.49999H7.8335Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.057e680c6ee53cbfe7054b2a8fcd19bd.svg";
export { ForwardRef as ReactComponent };